import script from "./traffic-ranking-chart.vue?vue&type=script&setup=true&lang=ts"
export * from "./traffic-ranking-chart.vue?vue&type=script&setup=true&lang=ts"

import "./traffic-ranking-chart.vue?vue&type=style&index=0&id=2915af5e&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2915af5e"]])

export default __exports__